module.exports = __webpack_public_path__ + "static/media/home-02.e2e0697f.png";